import React from 'react';
import {
  CardSmallText,
  CardText,
  CustomCard,
  CustomCardContent,
  IconRow,
  InsightsCardTitle,
} from 'spw-esa-projects/building-details/occupancy-and-utilization/cards/styles';
import { Box } from '@mui/material';
import { RoundSingleSummary } from 'spw-redux/modules/ou/types';
import { numberWithCommasOrDash } from 'spw-shared/utils';
import { ALL_CATEGORIES } from 'spw-esa-projects/building-details/occupancy-and-utilization/cards/constants';
import {
  AMENITY_SPACES_CATEGORY,
  INDIVIDUAL_WORKSPACES_CATEGORY,
  MEETING_SPACES_CATEGORY,
  SUPPORT_SPACES_CATEGORY,
} from 'spw-constants';
import { TabValue } from 'spw-esa-projects/building-details/occupancy-and-utilization/types';
import {
  ColorDot,
  CategoryDotWrapper,
} from 'spw-esa-projects/building-details/occupancy-and-utilization/styles';
import { useCategoryColor } from 'spw-esa-projects/building-details/occupancy-and-utilization/cards/hooks';

type Props = {
  category: TabValue;
  summary?: RoundSingleSummary;
};

const iconsByCategory: { [key: string]: string } = {
  [ALL_CATEGORIES]: 'meeting-3',
  [INDIVIDUAL_WORKSPACES_CATEGORY]: 'workstation-default',
  [MEETING_SPACES_CATEGORY]: 'meeting-category-default',
  [AMENITY_SPACES_CATEGORY]: 'custom-amenity-default',
  [SUPPORT_SPACES_CATEGORY]: 'satellite-copy-default',
};

const UnobservedSpaces = ({ category, summary }: Props) => {
  const unobservedSpaces = summary?.existing - summary?.observed;
  const color = useCategoryColor(category);

  return (
    <CustomCard elevation={0} className="margin-top-16">
      <CustomCardContent>
        <InsightsCardTitle>
          <CategoryDotWrapper>
            <ColorDot color={color} className="colorDot" />
          </CategoryDotWrapper>
          <Box display="flex">UNOBSERVED SPACES</Box>
        </InsightsCardTitle>
        <IconRow style={{ marginTop: 24 }}>
          <Box className="card-icon">
            <img
              alt="meeting-seat-icons"
              src={`/images/space-icons/${
                iconsByCategory[category as string]
              }.svg`}
              height={32}
            />
          </Box>
          <Box
            className="value"
            display="flex"
            alignItems="center"
            justifyContent="center"
          >
            {numberWithCommasOrDash(unobservedSpaces)}
          </Box>
        </IconRow>
        <CardSmallText>
          Unobserved Spaces are excluded from calculations
        </CardSmallText>
        <CardText>
          <p>
            <b>{numberWithCommasOrDash(summary?.existing)}</b> Existing Spaces –
          </p>
          <p>
            <b>{numberWithCommasOrDash(summary?.observed)}</b> Observed Spaces
          </p>
        </CardText>
      </CustomCardContent>
    </CustomCard>
  );
};

export default UnobservedSpaces;
